<template>
  <SearchContainer>
    <template slot="default">
      <div class="row">
        <div class="col-12 col-sm-3 mb-3">
          <Input
            type="datepicker"
            :label="$t('sections.logsmLandingPage.search.start')"
            :field="query.start"
            @input="(e) => onInput('start', e)"
          />
        </div>
        <div class="col-12 col-sm-3 mb-3">
          <Input
            type="datepicker"
            :label="$t('sections.logsmLandingPage.search.end')"
            :field="query.end"
            @input="(e) => onInput('end', e)"
          />
        </div>
        <div class="col-12 col-sm-3 mb-3">
          <Input
            type="dropdown"
            :label="$t('sections.logsmLandingPage.search.component')"
            :items="$t('sections.logsmLandingPage.search.componentOptions')"
            :field="query.component"
            @input="(e) => onInput('component', e)"
          />
        </div>
        <div class="col-12 col-sm-3 mb-3">
          <Input
            type="dropdown"
            :label="$t('sections.logsmLandingPage.search.module')"
            :items="$t('sections.logsmLandingPage.search.moduleOptions')"
            :field="query.module"
            @input="(e) => onInput('module', e)"
          />
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <el-button
          type="primary"
          @click="search"
          class="mb-3"
        >
          <font-awesome-icon icon="fa-regular fa-magnifying-glass" class="mr-2" />
          {{ $t("sections.common.search.searchButton") }}
        </el-button>
      </div>
    </template>
  </SearchContainer>
</template>

<script>
import SearchContainer from '@/components/sections/common/SearchContainer.vue';
import Input from '@/components/ui/Input.vue';

export default {
  name: 'LogsManagerSearchOptions',
  components: {
    SearchContainer,
    Input,
  },
  data() {
    return {
      query: {
        start: '',
        end: '',
        component: '',
        module: '',
      },
    };
  },
  methods: {
    onInput(field, value) {
      this.query[field] = value;
    },
    search() {
      this.$emit('onSearch', this.query);
    },
    resetFilters() {
      this.query = {
        start: '',
        end: '',
        user: '',
        result: '',
      };

      this.$emit('onSearch', this.query);
    },
  },
};
</script>
<style lang="scss" scoped>
.options-container {
  --input-label-width: 90px;
}
</style>
